export default __webpack_public_path__ + "static/media/attachment.f586f0ec.svg";